import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Constants } from '../../constants/constants';
import { UserDataDto } from '../../dto/auth/user-data.dto';
import { catchError, map, of } from 'rxjs';
import { AdministracionUsuariosService } from '../../modules/administracion-usuarios/services/administracion-usuarios.service';

export const admFuncionalLiderGuard: CanActivateFn = (route, state) => {
  const admUsuariosService = inject(AdministracionUsuariosService);
  const router = inject(Router);
  const idEntidad = route.params['idEntidad'];
  const idUsuarioEditar = route.params['idUsuario'];
  let idUsuarioLogin = 0;
  const usuario = sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE);
  const infoInicioSesion = JSON.parse(
    sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
  );
  if (usuario) {
    const userData: UserDataDto = JSON.parse(usuario);
    idUsuarioLogin = userData.idUsuario ?? 0;
  }
  if (idEntidad) {
    // si es creación de usuario
    return admUsuariosService
      .getPermisoAdmLiderByUsuarioEntidad(idUsuarioLogin, idEntidad)
      .pipe(
        map(response => {
          if (response?.success) {
            return true;
          } else {
            router.navigate(['/']);
            return false;
          }
        }),
        catchError(error => {
          console.error(error);
          router.navigate(['/']);
          return of(false);
        })
      );
  } else if (idUsuarioEditar) {
    // si es modificación de usuario
    return admUsuariosService
      .getPermisoAdmFuncionalByUsuarioEntidad(
        idUsuarioEditar,
        infoInicioSesion.Id_Entidad
      )
      .pipe(
        map(response => {
          if (response?.success) {
            return true;
          } else {
            router.navigate(['/']);
            return false;
          }
        }),
        catchError(error => {
          console.error(error);
          router.navigate(['/']);
          return of(false);
        })
      );
  }
  return false;
};
